module.exports = __webpack_public_path__ + "img/404.7abbb1a2.svg";